/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["td[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{padding-top:0;padding-bottom:0}.header[_ngcontent-%COMP%]{font-weight:700;text-align:center;background-color:#eee;width:90px;border:1px solid #ccc!important;color:#000}form[_ngcontent-%COMP%]{padding-top:20px;padding-left:15px;padding-right:15px}.vam[_ngcontent-%COMP%]{vertical-align:middle}.w30p[_ngcontent-%COMP%]{width:30%}.w20p[_ngcontent-%COMP%]{width:20%}.form-group[_ngcontent-%COMP%]{margin-bottom:5px}td[_ngcontent-%COMP%]{padding-bottom:5px;padding-top:5px}"];
export { styles as styles };
